import { useTheme } from '@material-ui/core';

import { Theme } from '../config/types';

export function useCustomTheme() {
  return useTheme() as Theme;
}
